// Sets up nav open/close functionality
jQuery(document).ready(function($){

	function RefreshCart(runAgain, fn) {
		if( runAgain != true ) {
			$.get('/')
				.done(function(data){
					var el = $(data);
					var selectors = [
						'#cart--modal--content',
						'#site--header--cart--link.show-modal',
						'.mobile #site--header--cart--link',
						'#modal--cart--subtotal'
					]
					for(var i = 0; i < selectors.length; i++) {
						var s = selectors[i];
						$(s).html(el.find(s).html());
					}
					if( fn instanceof Function ) {
						fn();
					}
				})
				.fail(function(){
					RefreshCart(true);
				});
		}
	}

	$('#addToCartForm').submit(function(e){
		e.preventDefault();
		$.post('/cart/add.js', $(this).serialize())
			.always(function(){
				RefreshCart(false, function(){
					$('#site--header--cart--link').trigger('click');
				})
			});
	});

	$('#products-list .product--table--cloth .flex-row:not(.flex-header)').each(function(){
		var defaultQuantity = 1;
		var row = $(this),
			input = row.find('.item-quantity');
		input.blur(function(){
			ValidateValue($(this));
		});
		input.keydown(function(e){
			// Check if user pressed enter
			if( e.keyCode == 13 ) {
				ValidateValue($(this));
				row.find('.add').click();
			}
		})
		function ValidateValue(el) {
			try {
				var q = parseInt(el.val());
				el.val( isNaN(q) ? defaultQuantity : q);
			} catch(e) {
				el.val(defaultQuantity);
			}
		}

		function SetupAddButton(row) {
			row.find('.add').click(function(e){
				var cover = row.find('.cover');
				cover.fadeIn(300, function(){
					var item = row.find('.item-quantity');
					var id  = item.attr('data-id'),
						qty = item.val() | 0;

					if( !isNaN(qty) && 0 < qty ) {
						item.val(defaultQuantity);

						$.post('/cart/add.js', { id: id, quantity: qty })
						.always(function(xhr){
							if( xhr.status == 200 && xhr.readyState == 4 ) {
								setTimeout(function(){
									cover.fadeOut();
								}, 1000);
								RefreshCart();
							}
						});
					}
				});
			});
		}

		SetupAddButton(row);
	});



	function closeNav() {
		$('#site-sidebar').removeClass('fill-page');
	        $('#site-sidebar-mask').removeClass('visible');
            	$('body').removeClass('site-open-nav');
	}

	function openNav() {
		$('#site-sidebar').addClass('fill-page');
	        $('#site-sidebar-mask').addClass('visible');
                setTimeout( $('body').addClass('site-open-nav'), 300 );
	}

	function navIsOpen() {
		return $('body').hasClass('site-open-nav');
	}


	$('#site-hamburger-menu').click(function(){
		if( navIsOpen() )
			closeNav();
		else
			openNav();
	});

	$('#site-sidebar-mask').click(closeNav);

	$('#site-sidebar #site-nav--modal').show();


	$('.link-scroll-animate').click(function(e){
		var sel = $(this).data('hash');
		if( sel == "#home-all-products") {
			if( location.pathname === '/' ) {
				e.preventDefault();
				closeNav();
				var sel = $(this).data('hash');
				if( window.innerWidth < 768 ) {
					var headerHeight = $('#site-sidebar .logo-container').outerHeight();
				}  else {
					var headerHeight = 0;
				}
				$('html, body').animate({
				    scrollTop: $(sel).offset().top - headerHeight
				 }, 1000);
			}
		} else {
			e.preventDefault();
			if( window.innerWidth < 768 ) {
				var headerHeight = $('#site-sidebar .logo-container').outerHeight();
			}  else {
				var headerHeight = 0;
			}
			$('html, body').animate({
			    scrollTop: $(sel).offset().top - headerHeight
			 }, 1000);
		}
	});

	$('#filter-bulk-options .flex-table .flex-row').on('change', 'select', function(e) {
		var select = $(this).val();
		var el = $(e.delegateTarget);
		el.attr('data-variant', select);

		var id = $(this).find(':selected').data('id');
		el.find('.item-quantity').attr('data-id',id);
	});
});

jQuery(document).ready(function($){

	$('#home-all-products .product h5').each(function(){
		var el = $(this);
		el.text(el.text().trim().replace('.00',''));
	});

	function checkScrollPosition() {
	    var scroll = $(window).scrollTop();

	    if( scroll > 0 ) {
	    	$('body').addClass('scrolled');
	    } else {
	    	$('body').removeClass('scrolled');
	    }
	}
	checkScrollPosition();
	$(window).scroll(checkScrollPosition);
});

var nWindowWidth = window.innerWidth;

function updateGlobalVars() {
	nWindowWidth = window.innerWidth;
}

var has_setupAlertEtc_ran = false;

function setupAlertEtc() {
	if( has_setupAlertEtc_ran ) {
		return;
	}
	has_setupAlertEtc_ran = true;
 	updateGlobalVars();

 	//check for multiple site alerts
 	var nSiteAlerts = $('#site_alert').find('li').length,
 		alertsInterval;

 	function autoChangeSiteAlerts() {
 		alertsInterval = setInterval(function() { nextSiteAlert() }, 4300);
 	}

 	function clearAlertsInterval() {
 		clearInterval(alertsInterval);
 	}

 	if( nSiteAlerts > 1 ) {
 		autoChangeSiteAlerts();

	 	$(document).on('mouseenter', '#site_alert', function() {
	 		clearAlertsInterval();
	 	}).on('mouseleave', '#site_alert', function() {
	 		autoChangeSiteAlerts();
	 	})
 	}


 	function nextSiteAlert() {
 		var oSiteAlerts = $('#site_alert'),
 			oActiveAlert = oSiteAlerts.find('.active'),
 			nActiveAlertIndex = oActiveAlert.index(),
 			nLastAlertIndex = nSiteAlerts - 1,
 			nNextAlertIndex = 0;

 		if(nActiveAlertIndex != nLastAlertIndex) {
 			var nNextAlertIndex = nActiveAlertIndex + 1;
 		}

 		var oNextAlert = oSiteAlerts.find('li:eq('+nNextAlertIndex+')');

 		// oActiveAlert.css('top', '0px').animate({'top': '-24px'}, 300, 'swing', function() {
 		// 	$(this).removeClass('active');
 		// })
 		// oNextAlert.css('top', '24px').animate({'top': '0px'}, 300, 'swing', function() {
 		// 	$(this).addClass('active');
 		// })
		oActiveAlert.css('opacity', '1').fadeTo(300, 0, function() {
			$(this).removeClass('active');
		})
		oNextAlert.css('opacity', '0').fadeTo(300, 1, function() {
			$(this).addClass('active');
		})


 	}


 	$(window).resize(function() {
 		updateGlobalVars();
 	})

 	$(document).on('click', '.openNewsletterModal', function(e) {
 		e.preventDefault();

 		$('#newsletter--modal').fadeTo(300, 1);
 	})

 	$('#newsletter--modal').on('click', '.close-modal', function(e) {
 		e.preventDefault();

 		$('#newsletter--modal').fadeTo(300, 0, function() {
 			$(this).hide();
 		})
 	})

	/* Toggle account form type */
	var oAccountToggle = $('#account-form-toggle');


	function accountFormTypeChanged() {
		var sFormTypeSelected = $("input[name='account-form-type']:checked").val();

		$('#account-forms').find('.active').removeClass('active').addClass('hidden');
		$('#' + sFormTypeSelected + '-form-wrapper').removeClass('hidden').addClass('active');
	}

	if(oAccountToggle) {
		$(document).on('change', "input[name='account-form-type']", function() { accountFormTypeChanged(); });
	}

	$(document).on('click', '.show-modal', function(e) {
		e.preventDefault();

		var oClicked = $(this),
			sModalID = oClicked.data('modal'),
			sModalLevel = oClicked.data('level'),
			sModalSide = oClicked.data('side'),
			oClickedModal = $('#'+sModalID),
			oClickedModalWrapper = $('#'+ sModalSide +'-side-modals'),
			oClickedModalWrapperInner = oClickedModalWrapper.find('.side-modals-wrapper-inner'),
			oClickedModalLevel = oClickedModalWrapper.find('.'+ sModalLevel + '-modals'),
			bModalInCorrectLocation = oClickedModalLevel.find('#'+sModalID).length;

		//check to see if modal is in the desired location
		if(bModalInCorrectLocation == 0) {
			//if not, move modal to desired location
			oClickedModal.remove().appendTo(oClickedModalLevel);
		}

		//hide all other modals at the same level
		oClickedModalLevel.find('.sw-modal').removeClass('visible');

		//show the clicked modal
		oClickedModal.addClass('visible');

		if(sModalLevel == 'primary') {
			//slide in the modal wrapper
			if( sModalID === "cart--modal" ) {
				var bod = $('body');
				bod.addClass('site-open-nav-right');
				oClickedModalWrapper.addClass('visible');
			} else {
				oClickedModalWrapper.addClass('visible');
			}

			//show the modal mask
			showModalMask();
		}

		if(sModalLevel == 'secondary') {
			//slide over the the modal
			oClickedModalWrapperInner.addClass('show-secondary');
		}

		//check if search modal is activated
		if(sModalID == 'search--modal') {
			//auto target the search field
			setTimeout( function() {$('#search--modal--header').find('form').find('input[type=search]').focus(); }, 250);
		}
	})

	$(document).on('click', '.modal-back', function(e) {
		e.preventDefault();

		var oClicked = $(this),
			oClickedModalWrapperInner = oClicked.parents('.side-modals-wrapper-inner');

		oClickedModalWrapperInner.removeClass('show-secondary');
	});

	function clearSearch() {
		var oForm = $('#search--modal--header').find('form'),
			oSearchField = oForm.find('input[name=q]'),
			oClearBtn = oForm.find('.clear-search');

		//clear the search field value
		oSearchField.val('');

		//hide the clear btn
		oClearBtn.removeClass('visible');

		//focus on the search input field to prevent user from clicking again to start typing
		oSearchField.focus();

		//if search has already been preformed, clear the search content
		var oModalContent = $('#search--modal--content');

		if(!oModalContent.find('.inner').hasClass('empty-search')) {
			oModalContent.find('.inner').fadeOut(250, function() {
				$(this)
					.addClass('empty-search')
					.html('<p class="instructions">Type a search term above and <br>click enter to start searching.</p>')
					.hide()
					.fadeIn(250);
			})
		}
	}

	$(document).on('click', '#search--modal--header .clear-search', function(e) {
		e.preventDefault();

		clearSearch();
	})

	function performSearch() {
		var oForm = $('#search--modal--header').find('form'),
			sFormData = oForm.serializeArray(),
			sFormURL = oForm.attr('action');
		console.log(sFormData[1].value)
		$.ajax({
			url: sFormURL,
			type: 'POST',
			data: sFormData,
			success: function(data) {
				var oSearchResults = $(data).find('#searchResultsForModal');

				$('#search--modal--content').find('.inner').fadeOut(250, function() {
					$(this).removeClass('empty-search').html(oSearchResults).fadeIn(500);
				})
			}
		})
	}

	var delay = (function(){
		var timer = 0;
		return function(callback, ms){
			clearTimeout (timer);
			timer = setTimeout(callback, ms);
		};
	})();


	$(document)
		.on("keyup", '#search--modal--header form input', function() {
			if($(this).val() == '') {
				clearSearch();
			}
		}).on("keydown.autocomplete", '#search--modal--header form input',function() {
			$(this).parent().find('.clear-search').addClass('visible');

			$(this).autocomplete({
				source: searchAutocompleteTerms,
				appendTo: "#search--modal--header--autocomplete",
				select: function() {
					setTimeout(performSearch, 1);
				}
			})
		});

	$(document).on('submit', '#search--modal--header form', function(e) {
		e.preventDefault();
		performSearch();
	})

	// $(document).on('keyup', '#search--modal--header form input', function() {
	// 	delay(performSearch, 250);
	// })

	$(document).on('click', '.modal--header .close, .modal--content .close-modal', function(e) {
		e.preventDefault();
		$('#modal--mask').trigger('click');
	})

	$(document).on('click', '#modal--mask', function(e) {
		e.preventDefault();

		hideModalMask();
		$('#newsletter--modal').removeClass('visible');
		$('#left-side-modals').removeClass('visible');
		$('#right-side-modals').removeClass('visible');
		$('body').removeClass('site-open-nav-right');
		setTimeout(
			function() {
				$('#left-side-modals').find('.side-modals-wrapper-inner').removeClass('show-secondary');
				$('#right-side-modals').find('.side-modals-wrapper-inner').removeClass('show-secondary');
			}, 250
		);
	})

	$(document).on('click', '.remove-from-cart', function(e) {
		e.preventDefault();

		var oClicked = $(this),
			oProduct = oClicked.parents('.product'),
			nProductID = oClicked.data('id');

		$.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data:  'quantity=0&id='+nProductID,
			dataType: 'json',
			success: function(cart) {
				//remove item from modal
				oProduct.slideUp(500, function() {
					$(this).remove()
				})

				//get updated cart info
				updateModalCartInfo();
			},
			error: function(XMLHttpRequest, textStatus) {
				alert('Error');
			}
		})

	})


	$(document).on('click', '#addToCart', function(e) {
		e.preventDefault();

		var oForm = $(this).parents('form'),
			sFormData = oForm.serializeArray(),
			sFormURL = oForm.attr('action');

		$.ajax({
			url: sFormURL,
			type: 'POST',
			data: sFormData,
			success: function(data) {
				var oContentForModal = $(data).find('#cart--modal--content').html();
				$('#cart--modal--content').html(oContentForModal);
				$('#site--header--cart--link').trigger('click');
				updateModalCartInfo();
			},
			error: function() {
				oForm.submit();
			}
		})

	})

	$('.cart--special-instructions').on('click', 'label', function(e) {
		$(this).parent().find('.textarea-wrapper').slideDown();
	})


	$(".carousel").swipe({
		//Generic swipe handler for all directions
		swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
			if( direction == 'left' ) {
				//trigger prev click
				$(this).carousel('next');
			} else if ( direction == 'right' ) {
				//trigger next click
				$(this).carousel('prev');
			}
		},
		allowPageScroll:"vertical",
		excludedElements: ""
	});

}

$(document).ready(setupAlertEtc);
$(window).load(setupAlertEtc);


function updateModalCartInfo() {
	$.getJSON('/cart.js', function(data) {
		var sSubtotal = '';

		if(data.item_count > 0) {
			sSubtotal = Shopify.formatMoney(data.total_price);
		} else {
			sSubtotal = '$ 0.00';
		}
		//update subtotal
		$('#modal--cart--subtotal').html(sSubtotal);

		//update cart count
		$('.cartCount').html(data.item_count);
	});
}

function showModalMask() {
	$('#modal--mask').addClass('enabled');
}

function hideModalMask() {
	$('#modal--mask').removeClass('enabled');
}

/* Recover password form */
function getID(id){ // http://jsperf.com/getelementbyid-vs-jquery-id/44
  return jQuery(document.getElementById(id));
}

var recoverForm = getID('customer-recover-password-form'),
loginForm = getID('customer-login-form');

function showRecoverPasswordForm() {
  recoverForm.parent().show();
  loginForm.parent().hide();
}

function hideRecoverPasswordForm() {
  recoverForm.parent().hide();
  loginForm.parent().show();
}

$(document).on('click', '.hide-recover-password-form', function(e){
  hideRecoverPasswordForm();
  e.preventDefault();
});

$(document).on('click', '.show-recover-password-form', function(e){
  showRecoverPasswordForm();
  e.preventDefault();
});

// dont show links if we dont have both includes present
if(recoverForm === null){ getID('forgotten-password-link').style.display='none'; }
if(loginForm === null){ getID('recover-password-link').style.display='none'; }

hideRecoverPasswordForm();
if (window.location.hash === '#recover') { showRecoverPasswordForm(); }

$('#mc-embedded-subscribe-form').ajaxChimp({
    callback: callbackFunction
});

function callbackFunction (resp) {
    if (resp.result === 'success') {
        // Do stuff
        $('#mc-submit-error').fadeTo(500, 0);
        $('#mc-embedded-subscribe-form').fadeOut(500, function() {
        	$('#mc-submit-success').removeClass('hide').hide().fadeTo(500, 1)
        });
    }
    if (resp.result === 'error') {
        // Do stuff
        $('#mc-submit-error').removeClass('hide').hide().fadeTo(500, 1);
    }
}


$('#newsletter-signup-modal #mc-embedded-subscribe-form').ajaxChimp({
    callback: callbackFunction2
});

function callbackFunction2 (resp) {
    if (resp.result === 'success') {
        // Do stuff
        $('#newsletter-signup-modal #mc-submit-error').fadeTo(500, 0);
        $('#newsletter-signup-modal #mc-embedded-subscribe-form').fadeOut(500, function() {
        	$('#newsletter-signup-modal #mc-submit-success').removeClass('hide').hide().fadeTo(500, 1)
        });
    }
    if (resp.result === 'error') {
        // Do stuff
        $('#newsletter-signup-modal #mc-submit-error').removeClass('hide').hide().fadeTo(500, 1);
    }
}


$(document).on('click', '#cart--modal--content .modifier', function(e) {
	e.preventDefault();

	var clicked = $(this),
		product = clicked.parents('.product'),
		productIndex = product.index(),
		productID = product.data('id'),
		productQty = parseInt(product.find('.qty').html()),
		productQtyMax = parseInt(product.find('.qty').data('max-qty')),
		productMinus = clicked.hasClass('minus'),
		ajaxURL = '/cart/change.js',
		ajaxPostData = { quantity: (productQty + 1), id: productID },
		ajaxType = 'change';

	if(productMinus) {
		ajaxPostData = { quantity: (productQty - 1), id: productID };

		//check if product qty equals on
		if(productQty === 1) {
			ajaxType = 'remove';
		}
	}
	$.ajax({
		type: "POST",
		url: ajaxURL,
		data: ajaxPostData,
		success: function(data) {
			var updatedCartItems = data.item_count,
				updatedCartTotal = Shopify.formatMoney(data.total_price);

			//check if product was removed from cart
			if(productMinus && productQty === 1) {
				product.slideUp(500, function() {
					$(this).remove()
				})
			} else {
				var updatedProductQty = data.items[productIndex].quantity,
					updatedProductTotal = Shopify.formatMoney(data.items[productIndex].line_price);

				if(productMinus) {
					//show plus sign
					product.find('.modifier.plus').removeClass('hidden');
				} else {
					//check if plus sign should be hidden
					if(productQtyMax === updatedProductQty) {
						//hide pluse sign
						product.find('.modifier.plus').addClass('hidden');
					}
				}

				//updated product qty
				product.find('.qty').html(updatedProductQty);

				//update product total
				product.find('.price').html(updatedProductTotal);
			}
			//update cart total
			$('#modal--cart--subtotal').html(updatedCartTotal);

			//update cart counters
			$('.cartCount').html(updatedCartItems);


			console.log(data);

		},
		error: function(data) {
			alert('Sorry, there was an error with your request. Please try again.')
		},
		dataType: 'json'
	})
})

if( $('.siteFooter__reviews__list').length ) {
	var has_siteFooter_run = false;
	function siteFooterOwlCarousel() {
		if( has_siteFooter_run ) {
			return;
		}
		has_siteFooter_run = true;
		$(".siteFooter__reviews__list").owlCarousel({
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			stopOnHover: true,
			nav: false,
			singleItem: true,
			autoHeight: true,
			transitionStyle: "fade",
			pagination: false,
			items: 1
		});
	}
	$(document).ready(siteFooterOwlCarousel);
	$(window).load(siteFooterOwlCarousel);
}
